<aside
	class="side-panel-container"
	[@panelSlide]="animationState"
	(@panelSlide.done)="onAnimationDone($event)"
	[style.visibility]="renderReady() ? 'visible' : 'hidden'"
>
	<!-- <sp-icon
		class="close-panel-button"
		[ngClass]="hasCloseBackground() ? 'icon-white-transparent' : 'icon-teal'"
		filename="close"
		(click)="onClosePanel()"
	></sp-icon> -->

	@if (hasSeeAllButton) {
		<sp-icon
			class="see-all-button"
			[ngClass]="hasCloseBackground() ? 'icon-white-transparent' : 'icon-teal'"
			filename="arrow-left"
			(click)="onSeeAllButton()"
		></sp-icon>
	}
	<div #sidePanelScroll id="sidePanelScroll" class="side-panel-content">
		<router-outlet name="panel"></router-outlet>

		<div class="side-panel-footer"></div>
	</div>
</aside>
